import Api from '@/api'

export default {
    namespaced: true,
    state: {
        fio: '',
        gender: '',
        email: '',
        age: 0,
        phone: '',
        education: '',
        activity: '',
        company: ''
    },
    actions: {
        async fetch ({commit, dispatch}) {
            let data = await Api.GET('api/user/view')

            if (data.msg === 'no login') {
                dispatch('auth/logout', {}, {root:true})
            } else {
                dispatch('testing/stages', data.stages, {root: true})
                commit('auth/role', data.code.role_id, {root: true})
                commit('profile', data)
            }
        },
        async update ({commit}, {fio, email, gender, age, phone, education, activity, company}) {
            age = +age || 0
            education = education || ''
            activity = activity || ''
            await Api.POST('api/user/edit', {fio, email, gender, age, phone, education, activity, company})
            commit('profile', {fio, email, gender, age, phone, education, activity, company})
        },
        async updateStages ({dispatch, commit}, {stages = [], respondent = 'free_access'}) {
            const data = await Api.POST('api/user/stage', {stage: stages.join(','), respondent})
            commit('auth/role', data.code.role_id, {root: true})
            dispatch('testing/stages', stages, {root: true})
        }
    },
    mutations: {
        profile (state, {fio, gender, age, phone, email, education, activity, company}) {
            state.fio = fio
            state.gender = gender
            state.age = age
            state.email = email
            state.phone = phone
            state.education = education
            state.activity = activity
            state.company = company
        }
    }
}
